<template>
  <v-container>
    <v-card class="mx-auto" flat>
      <v-row>
        <v-col>
          <p class="headline font-weight-bold" style="color:#AF8936; font-size: 27px !important;">
            Publicación de Edictos
          </p>
          <div class="parrafo mt-2">
            <p style="font-size: 16px">
              En cumplimiento a lo dispuesto por el artículo 17 de la <b>Ley para la Declaración Especial de Ausencia por Desaparición de Personas del Estado de Jalisco </b>, se lleva a cabo la siguiente publicación de Edictos
            </p>
          </div>
        </v-col>
      </v-row>

      <v-divider class="mb-2"></v-divider>
      <v-row>
        <v-col align="right">
          <v-dialog v-model="dialog" max-width="700px" persistent>
          <template v-slot:activator="{ on }">
            <div>
              <v-btn
                v-if="isLoggedIn"
                tile
                small
                color="#1E2F4C"
                dark
                v-on="on"
              >
                <v-icon left>
                  mdi-upload
                </v-icon>
                Publicar Edicto
              </v-btn>
            </div>
          </template>
        <v-card>
          <v-card-title class="headline grey lighten-2">
            <span>{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                <v-row class="mb-n7">
                  <v-col cols="12">
                    <v-autocomplete
                      label="Municipio"
                      dense
                      outlined
                      v-model="editedItem.municipio_id"
                      :items="listMunicipios"
                      :rules="notBlankRules"
                      prepend-icon="mdi-map-marker"
                      item-text="nombre"
                      item-value="id"
                      no-data-text="No hay Municipios"
                      v-on:change="getJuzgadosForm()"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row class="mb-n7">
                  <v-col cols="12">
                    <v-select
                      label="Juzgado"
                      dense
                      outlined
                      v-model="editedItem.juzgado_id"
                      :items="listJuzgadosForm"
                      :rules="notBlankRules"
                      item-text="nombre"
                      item-value="id"
                      prepend-icon="mdi-gavel"
                      no-data-text="No hay Juzgados"
                    ></v-select>
                  </v-col>
                </v-row>
                <br>
                <v-row class="mb-n7">
                  <v-col cols="12" md="4" class="mb-n10">
                    <v-text-field outlined dense v-model="editedItem.letra" label="Letra"
                      prepend-icon="mdi-format-letter-starts-with"
                      type="text"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="8" class="mb-n4">
                    <h4 style="color: red" class="mt-2">
                      Usa este campo si el expediente trae letra al inicio (L12/2025).
                    </h4>
                  </v-col>
                </v-row>
                <v-row class="mb-n7 mt-12">
                  <v-col cols="12" sm="5">
                    <v-text-field outlined dense v-model="editedItem.numero" label="Número de Expediente"
                      prepend-icon="mdi-folder"
                      type="text"
                      placeholder="1234"
                      :rules="numberRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field outlined dense
                      v-model="editedItem.periodo"
                      label="Período"
                      type="number"
                      :rules="periodoRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-text-field outlined dense v-model="editedItem.derivado" label="Derivado"
                      placeholder="A"
                      @input="v => { editedItem.derivado = v.toUpperCase() }"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <br>
                <v-row class="mb-n7">
                  <v-col cols="12" sm="12">
                    <v-text-field outlined dense v-model="editedItem.nombre" label="Nombre Funcionario"
                    prepend-icon="mdi-account"
                    type="text"
                    placeholder="Nombre Funcionario"
                    :rules="notBlankRules"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <br>
                <v-row class="mb-n7">
                  <v-col cols="12" sm="6">
                    <v-text-field outlined dense v-model="editedItem.primer_apellido" label="Primer Apellido Funcionario"
                    prepend-icon="circle-small"
                    type="text"
                    placeholder="Primer Apellido Funcionario"
                    :rules="notBlankRules"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field outlined dense v-model="editedItem.segundo_apellido" label="Segundo Apellido Funcionario"
                    type="text"
                    placeholder="Segundo Apellido Funcionario"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <br>
              <v-row class="mb-n7">
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="dialogDate"
                    v-model="dialogDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :rules="[v => !!v || 'Seleccione Fecha de Publicación']"
                        v-model="editedItem.fecha_publicacion"
                        label="Fecha de Publicación"
                        prepend-icon="mdi-calendar-outline"
                        readonly
                        v-on="on"
                        dense
                        outlined
                        class="mr-9"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="editedItem.fecha_publicacion"
                        @input="dialogDate = false"
                        locale="es-mx"
                        min="2010-01-01"
                        :max="new Date().toISOString().substr(0, 10)"
                        >
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
                <v-row class="mb-n7">
                  <v-col cols="12" sm="12">
                    <v-textarea outlined dense v-model="editedItem.extracto" label="Extracto"
                    prepend-icon="mdi-text-short"
                    type="text"
                    placeholder="Extracto"
                    :rules="notBlankRules"
                    >
                  </v-textarea>
                  </v-col>
                </v-row>
                <br>
                <v-row class="mb-n7">
                  <v-col cols="12" sm="12">
                    <v-textarea outlined dense v-model="editedItem.leyenda" label="Leyenda"
                    prepend-icon="mdi-text"
                    type="text"
                    placeholder="Leyenda"
                    :rules="notBlankRules"
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
                <v-row class="mb-n7">
                  <v-col cols="12">
                    <v-file-input
                      v-model="file"
                      color="blue darken-2"
                      counter
                      label="Seleccionar Archivo"
                      multiple
                      prepend-icon="mdi-paperclip"
                      outlined
                      dense
                      show-size
                      accept="application/pdf"
                      :rules="fileRules"
                      @change="fileSelected()"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <br>
                <v-row>
                  <v-col cols="12">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" outlined @click.native="close">Cancelar</v-btn>
                      <v-btn v-if="editedIndex > -1" color="yellow darken-2" outlined @click.native="editPublicacion(editedItem)" :disabled="loading" :loading="loading">Actualizar</v-btn>
                      <v-btn v-else color="yellow darken-3" outlined @click.native="saveEdicto()" :disabled="loading || !valid" :loading="loading"> Guardar </v-btn>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
        </v-col>
      </v-row>

      <v-row class="mt-n7">
        <v-col>
          <p class="title" style="color:gray; font-size: 17px !important;" align="center">CONSULTA DE EDICTOS</p>
        </v-col>
      </v-row>

      <div class="parrafo mt-2">
        <p>Ingrese el número de Expediente a consultar ejemplo: <strong>23-2020</strong> y/o seleccione el Municipio y Juzgado</p>
      </div>

      <v-form @submit.prevent="save" ref="search" v-model="validateExpediente" lazy-validation>
        <v-row >
          <v-col cols="12" md="3">
            <v-text-field
              v-model.trim="number"
              label="Número de Expediente"
              clearable
              @blur="clear()"
              :rules="expedienteRules"
              outlined
              dense
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              :items="listMunicipios"
              v-model="municipio_id"
              label="Municipio"
              item-value="id"
              item-text="nombre"
              v-on:change="getJuzgados()"
              clearable
              dense
              outlined
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              :items="listJuzgados"
              v-model="juzgado_id"
              label="Juzgado"
              item-value="id"
              item-text="nombre"
              no-data-text="No hay Juzgados"
              clearable
              dense
              outlined
              :disabled="validateMunicipio"
            >
            </v-select>
          </v-col>
        </v-row>
        </v-form>
        <v-row class="mt-n9">
          <v-spacer></v-spacer>
          <v-col cols="12" md="2">
            <v-btn
              block
              tile
              color="#1E2F4C"
              @click.native="buscar()"
              :disabled="!validateExpediente"
              class="white--text"
              small
              >
              <v-icon>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
        </v-row>

      <v-row>
        <v-col>
          <h4 class="overline">Resultados de la consulta</h4>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="3" class="text-right">
          <div class="flex-grow-1" style="color:#AF8936">
            <!-- <h4 v-if="roleUser == 'enlace' && this.currentUser.sala_data.id == totalSala" >Total tocas sala {{this.currentUser.sala_data.id}}: {{tocasTotal}}</h4> -->
            <!-- <h4 v-if="roleUser == 'admin' || roleUser == 'superadmin'">Total Edictos: {{this.totalTocasAdmin}} </h4> -->
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            dense
            :headers="headers"
            :items="EdictosList"
            item-value="id"
            item-text="numero"
            class="elevation-1"
            :loading="loading"
            light
            actions
            :page.sync="page"
            :items-per-page="per_page_table"
            hide-default-footer
            @page-count="pageCount = $event"
            no-data-text="No se Encontraron Expedientes"
            elevation="7"
          >
            <template v-slot:item.expediente = "{item}">
              <td v-if="item.derivado">
                {{ item.letra }}{{ item.numero }}-{{ item.periodo}}-{{item.derivado}}
              </td>
              <td v-else>
                {{ item.letra }}{{ item.numero }}-{{ item.periodo}}
              </td>
            </template>
            <template v-slot:item.juzgado = "{item}">
              <td>{{ item.juzgados_data.nombre }}</td>
            </template>
            <template v-slot:item.fecha = "{item}">
              <td> {{ item.created_at | formatDate }}</td>
            </template>
            <!--<template v-slot:item.extracto = "{item}">
              <td>{{ item.extracto }}</td>
            </template>-->
            <template v-slot:item.action="{ item }">
              <v-btn
                v-if="item.file"
                x-small
                color="#616161"
                dark
                @click="getFile(item, 'visualizar')"
              >
                <v-icon left x-small>mdi-file</v-icon>
                Ver Edicto
              </v-btn>
              <!-- DESCARGAR -->
              <v-tooltip top v-if="item.file && (roleUser == 'superadmin' || roleUser == 'admin')">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    v-bind="attrs" 
                    v-on="on"
                    color="blue"
                    @click="getFile(item, 'descargar')"
                  >
                    <v-icon>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Descargar</span>
              </v-tooltip>
              <!-- COPIAR URL -->
              <v-tooltip top v-if="item.file && (roleUser == 'superadmin' || roleUser == 'admin')">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-on="on"
                    v-bind="attrs"
                    @click="copyURL(item)"
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copiar URL</span>
              </v-tooltip>
              <!-- SUBIR ARCHIVO (solo si no tiene file) -->
              <v-tooltip top v-if="isLoggedIn && !item.file">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="#FF9800"
                    @click="openRetryUpload(item)"
                  >
                    <v-icon>mdi-file-upload-outline</v-icon>
                  </v-btn>
                </template>
                <span>Subir archivo pendiente</span>
              </v-tooltip>
              <!-- INDICADOR SIN ARCHIVO -->
              <v-tooltip top v-if="!item.file && !isLoggedIn">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="#FF9800"
                    v-bind="attrs"
                    v-on="on"
                  >mdi-alert</v-icon>
                </template>
                <span>Sin documento</span>
              </v-tooltip>


              <!-- Eliminar-->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="(roleUser == 'superadmin' || roleUser == 'admin')"
                    icon
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="#F44336"
                    @click="deleteEdicto(item)"
                  >
                    <v-icon>mdi-delete-forever</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
              <!-- <v-btn
                v-if="(roleUser == 'superadmin' || roleUser == 'admin')"
                x-small
                color="#F44336"
                dark
                @click="deleteEdicto(item)"
              >
                <v-icon left x-small>
                  mdi-delete-forever
                </v-icon>
                eliminar
              </v-btn> -->
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination
              v-if="pagination.total > 1"
              v-model="pagination.current"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
              color="#AF8936"
            ></v-pagination>
          </div>

        </v-col>
      </v-row>

      <v-dialog
        v-model="progress"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="grey darken-2"
          dark
        >
          <v-card-text>
            Cargando Archivo
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogCopy"
        hide-overlay
        persistent
        width="150"
      >
        <v-card
          color="green"
          dark
        >
          <v-card-text class="mb-n5">
            <b class="ml-3 font-weight-black">Url copiada</b>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOGO RETRY UPLOAD -->
      <v-dialog v-model="dialogRetryUpload" max-width="500px" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Subir archivo pendiente
          </v-card-title>
          <v-card-text class="pt-4">
            <p>El edicto <strong>{{ retryItem ? retryItem.numero + '-' + retryItem.periodo : '' }}</strong> no tiene documento. Selecciona el archivo PDF para subirlo.</p>
            <v-file-input
              v-model="retryFile"
              color="blue darken-2"
              label="Seleccionar archivo PDF"
              prepend-icon="mdi-paperclip"
              outlined
              dense
              accept="application/pdf"
              :rules="[v => !!v || 'Selecciona un archivo']"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" outlined @click="closeRetryUpload">Cancelar</v-btn>
            <v-btn color="green darken-1" outlined @click="retryUploadEdicto" :disabled="!retryFile || loadingRetry" :loading="loadingRetry">Subir</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- modal con visor PDF embebido -->
      <v-dialog v-model="dialogPDF" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="#415364" dense flat>
            <v-icon left>mdi-file-pdf-box</v-icon>
            <v-toolbar-title>Visor de Edictos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small dark text @click="dialogPDF = false; pdfUrl = ''">
              <v-icon left small>mdi-close</v-icon>
              Cerrar documento
            </v-btn>
          </v-toolbar>
          <v-progress-linear
            v-if="pdfUrl && !pdfLoaded"
            indeterminate
            color="#415364"
          ></v-progress-linear>
          <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            @load="pdfLoaded = true"
            style="width: 100%; height: calc(100vh - 48px); border: none;"
          ></iframe>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
const Swal = require('sweetalert2');
  export default {
    data: () => ({
      environment: process.env.NODE_ENV,
      // path: process.env.VUE_APP_PATH_DOWNLOAD,
      //fecha_publicacion:new Date().toISOString().substr(0, 10),
      fecha_publicacion:'',
      dialogDate:false,
      dialogCopy:false,
      dialogPDF: false,
      pdfUrl: '',
      dialogRetryUpload: false,
      retryItem: null,
      retryFile: null,
      loadingRetry: false,
      pdfLoaded: false,
      valid: true,
      validateExpediente: true,
      validateMunicipio: true,
      // flag_juzgado: true,
      // totalSala:'',
      number:'',
      juzgado_id:'',
      // sala_id:'',
      municipio_id:'',
      numero:'',
      derivado:'',
      periodo:'',
      pagination: {
        current: 1,
        total: 0
      },
      per_page_table: 1,
      EdictosList:[],
      listJuzgados:[],
      listJuzgadosForm:[],
      // totalTocasAdmin:'',
      dialog: false,
      progress: false,
      loading:false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      file:[],
      files:[],
      archivo:{
        encode:'',
      },
      expedienteRules: [
        v => /^(\d+)(\-)(\d{4})(-[A-Z]*)*$/.test(v) || 'Ingrese formato valido',
      ],
      editedItem: {
        municipio_id:'',
        juzgado_id:'',
        letra:'',
        numero:'',
        periodo: new Date().getFullYear(),
        derivado:'',
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        extracto:'',
        leyenda:'',
        fecha_publicacion: new Date().toISOString().substr(0, 10),
      },
      defaultItem: {
        municipio_id:'',
        juzgado_id:'',
        letra:'',
        numero:'',
        periodo: new Date().getFullYear(),
        derivado:'',
        nombre:'',
        primer_apellido:'',
        segundo_apellido:'',
        extracto:'',
        leyenda:'',
        fecha_publicacion:new Date().toISOString().substr(0, 10),
      },
      editedIndex: -1,
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      fileRules: [
        v => (v && v.length > 0) || 'Selecciona un archivo',
        v => !v || !v.length || v.every(f => f.type === 'application/pdf') || 'Solo se permiten archivos PDF',
      ],
      numberRules: [v => !!v || 'Este campo es requerido',
                    v => /^[1-9][0-9]*$/.test(v) || 'Ingresa solo números sin iniciar con cero',],
      periodoRules: [
                     v => ( v >= 1900 ) || 'El año no puede ser menor  al año 1900',
                     v => ( v <= new Date().getFullYear() ) || 'El año no puede ser mayor al año actual',
                    ],
    }),
    computed:{
      headers(){
        if (this.isLoggedIn) {
          return [
            { text: 'Expediente', value: 'expediente' },
            { text: 'Juzgado', value: 'juzgado' },
            // { text: 'Url descarga', value: 'url' },
           //{ text: 'Extracto', value: 'extracto' },
            { text: 'Fecha de Publicación', value: 'fecha' },
            { text: 'Acciones', value: 'action', sortable: false }
          ]
        } else {
          return [
            { text: 'Expediente', value: 'expediente' },
            { text: 'Juzgado', value: 'juzgado' },
            //{ text: 'Extracto', value: 'extracto' },
            { text: 'Fecha de Publicación', value: 'fecha' },
            { text: 'Acciones', value: 'action', sortable: false }
          ]
        }
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Publicación' : 'Editar Publicación'
      },
      ...mapGetters([
        "roleUser", "isLoggedIn", "currentUser", "listMunicipios"
      ])
    },
    watch: {
      number: function (val) {
        if(!val){
          this.pagination.current = 1;
          this.number = '';
          this.validateExpediente = true;
          this.buscar()
          return this.$refs.search.resetValidation()
        }
      },
      juzgado_id (val){
        this.pagination.current = 1;
        if(!val){
          // this.validateExpediente = true;
          return this.$refs.search.resetValidation()
        }
      },
      municipio_id (val){
        this.pagination.current = 1;
        this.validateMunicipio = false;
        this.juzgado_id = '';
        if(!val){
          // this.validateExpediente = false;
          this.validateMunicipio = true;
          this.juzgado_id = ''
          return this.$refs.search.resetValidation()
        }
      }
    },
    mounted(){
      this.buscar()
      this.getMunicipios()
    },
    methods:{
      clear () {
        if (!this.number) {
          this.$refs.search.resetValidation()
          this.validateExpediente = true
        }
      },
      showEdicto() {

      },
      getMunicipios() {
        this.$store.dispatch("GET_MUNICIPIOS",  { url: "/municipios" } ).then(response => {
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getJuzgados() {
        this.$store.dispatch("GET_JUZGADOS",  { url: "/juzgados/"+this.municipio_id+"/municipios" } ).then(response => {
          // console.log(response.data);
          this.listJuzgados = response.data.data.juzgados
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getJuzgadosForm() {
        this.$store.dispatch("GET_JUZGADOS",  { url: "/juzgados/"+this.editedItem.municipio_id+"/municipios" } ).then(response => {
          // console.log(response.data);
          this.listJuzgadosForm = response.data.data.juzgados
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      async buscar() {
          if (this.number) {
            this.pagination.current = 1;
            var number = this.number
            number = number.split("-",3)
            this.numero = number[0];
            this.periodo = number[1];
            this.derivado = number[2];
          }  else {
            this.numero = '';
            this.periodo = '';
            this.derivado = '';
            this.validateExpediente = true
            this.$refs.search.resetValidation()
          }

          // Construir solo los parámetros que tengan valor
          let params = {};
          if (this.juzgado_id) params.juzgado_id = this.juzgado_id;
          if (this.municipio_id) params.municipio_id = this.municipio_id;
          if (this.numero) params.numero = this.numero;
          if (this.periodo) params.periodo = this.periodo;
          if (this.derivado) params.derivado = this.derivado;

          // reCAPTCHA: ahora lo maneja el interceptor de axios automáticamente.
          // Si el backend responde 403 con require_recaptcha, el interceptor ejecuta
          // grecaptcha.execute() y reintenta el request sin que el usuario note nada.

          this.loading = true;
          this.$store.dispatch("GET_EDICTOS", {
            url: "edictos?page=" + this.pagination.current,
            data: Object.keys(params).length ? params : undefined
          })
          .then((response) => {
            this.loading = false
            this.pagination.current = response.data.data.edictos.current_page;
            this.pagination.total = response.data.data.edictos.last_page;
            this.per_page_table = response.data.data.edictos.per_page;
            this.EdictosList = response.data.data.edictos.data;
            this.numero = '';
            this.periodo = '';
          })
          .catch(error => {
            this.loading = false;
            this.numero = '';
            this.periodo = '';
            console.log(error);

            let mensaje = 'Ingresa un numero de Expediente válido';
            if (error.response && error.response.status === 403) {
              mensaje = 'Error de verificación de seguridad. Recarga la página e intenta de nuevo.';
            }

            if (this.number || (error.response && error.response.status === 403)) {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: mensaje,
                confirmButtonText: "Aceptar"
              })
            }
            this.number = '';
          });
          this.$refs.search.resetValidation()
      },
      onPageChange() {
        this.buscar();
      },
      async saveEdicto() {
          if (!this.$refs.form.validate()) {
            return;
          }
          if (!this.file || !this.file.length) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Selecciona un archivo PDF'
            });
            return;
          }
    
          this.progress = true;
          this.loading = true;
    
          try {
            // 1. Solicitar presigned URL al backend
            const presignedResponse = await this.$store.dispatch("PRESIGNED_UPLOAD_EDICTO", {
              url: "/edicto/presigned-upload",
              data: {
                ...this.editedItem,
                file_name: this.file[0].name
              }
            });
    
            const { url, edicto_name, edicto } = presignedResponse.data;
    
            // 2. Subir archivo directamente a S3 con la presigned URL
            const fileToUpload = this.file[0];
            const s3Response = await axios.put(url, fileToUpload, {
              headers: {
                'Content-Type': 'application/pdf'
              }
            });
            console.log('Respuesta de AWS S3:', s3Response);
    
            // 3. Confirmar la subida al backend para actualizar el registro
            await this.$store.dispatch("CONFIRM_UPLOAD_EDICTO", {
              url: "/edicto/confirm-upload",
              data: {
                edicto_id: edicto.id,
                edicto_name: edicto_name
              }
            });

            // Éxito
            Swal.fire({
              icon: 'success',
              title: 'Edicto Guardado',
              showConfirmButton: false,
              timer: 1500
            });
            this.close();
            this.buscar();
          } catch (err) {
            console.log(err);
            let errorMsg = 'No se pudo guardar el edicto';
            if (err.response && err.response.data && err.response.data.message) {
              errorMsg = err.response.data.message;
            }
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMsg,
              confirmButtonText: 'Aceptar'
            });
          } finally {
            this.progress = false;
            this.loading = false;
          }
        },
      // saveEdicto() {
      //   if (!this.$refs.form.validate()) {
      //     return
      //   }
      //   this.FilesToUpload();
      //   this.progress = true
      //   this.loading = true
      //   var data = this.editedItem
      //   data.file = this.archivo
      //   this.$store.dispatch("SAVE_EDICTO", {
      //     url: "/edicto",
      //     data : data
      //   })
      //   .then((response) => {
      //     //console.log(response);


      //     if (response.data.status == 'ok') {
      //         Swal.fire({
      //           icon: 'success',
      //           title: 'Edicto Guardado',
      //           showConfirmButton: false,
      //           timer: 1500
      //         })
      //       this.close();
      //       this.progress = false
      //       this.loading = false
      //        this.buscar()
      //        // if (this.roleUser == 'enlace') {
      //        //   // this.getTocasCount()
      //        // }
      //       }
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       Swal.fire({
      //         icon: 'error',
      //         title: 'Error',
      //         text: 'No se Guardo',
      //         showConfirmButton: false,
      //         timer: 1500
      //       })
      //       // this.progress = false
      //       this.loading = false
      //     });
      // },
      saveDocCA() {
        this.loadingFile=true
        // SI EL DOC PESA MAS DE 20 MEGAS, SE SUBE DIRECTO AL BUCKET
        if (this.s3presignedUrlCA!='') {
          this.file['file_name'] = this.file.name.split(".pdf")[0];
          this.file['nombre'] = this.file.name;
          Swal.fire({
            title: 'Subiendo Carpeta Administrativa...',
            html: 'Este proceso puede tardar varios minutos',
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            },
          })
          axios.put(this.s3presignedUrlCA, this.file, {
            headers: {
              'Content-Type': this.file.type
            }
          }
        ).then(response => {
            this.saveRegistroCA()
          }).catch( err => {
              console.log('FAILURE!!', err);
          });
        }
      },
      fileSelected(){
        var file = this.file[0];
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            // this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            // this.archivo['file_name'] = this.file[0].name
          });
        }
      },
      // getFile(item){
      //   this.progress = true
      //   this.$store
      //     .dispatch("GET_EDICTO", { url: "edicto/" + item.id + "/file" })
      //     .then((response) => {
      //       const link = document.createElement('a');
      //       console.log(response.data.data.presignedUrl);
      //       if (this.environment == 'development') {
      //       var showFile = response.data.data.presignedUrl // Pruebas local
      //     } else {
      //       var showFile = JSON.parse(response.data.data.presignedUrl.body); // Producción
      //     }
      //       //var showFile = response.data.data.presignedUrl // Pruebas local
      //     // var showFile = JSON.parse(response.data.data.presignedUrl.body); // producción
      //       link.href = showFile;
      //       link.setAttribute('target', '_blank');
      //       document.body.appendChild(link);
      //       link.click();
      //       this.progress = false;
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       this.progress = false;
      //       Swal.fire({
      //         icon: 'error',
      //         title: 'Error al obtener el archivo',
      //         confirmButtonText: "Aceptar"
      //       });
      //     });
      // },
      getFile(item, text){
      this.progress = true
      this.$store
        .dispatch("GET_FILE_EDICTOS", { id: item.id, modo: text == 'visualizar' ? 'visualizar' : 'descargar' })
        .then((response) => {
          const res = Array.isArray(response) ? response[0] : response;
          const url = res.data.data.url;
          if (text == 'descargar') {
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.id + '.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          if (text == 'visualizar') {
            this.pdfUrl = url;
            this.pdfLoaded = false;
            this.dialogPDF = true;
          }
          this.progress = false
        })
        .catch(err => {
          this.progress = false
          console.log('GET_FILE error:', err);
          this.$swal({
            title: 'Error al obtener el edicto',
            icon: 'error',
            text: 'No se pudo acceder al documento. Intente nuevamente.'
          })
        });
    },
    copyURL(item) {
      this.dialogCopy = true
      const el = document.createElement('textarea');
      el.value = 'https://edictos.stjjalisco.gob.mx/getfile/' + item.id;
      // el.value = 'http://localhost:8080/getfile/' + item.id;
      el.setAttribute('readonly', '');
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      var that = this;
      setTimeout(function () {
        that.dialogCopy = false
      }, 800);
    },
      // getFile(item){

      //   // const link = document.createElement('a');
      //   // link.href = "https://stjjalisco.gob.mx/files/home/Edicto.pdf";
      //   // link.setAttribute('target' ,'_blank');
      //   // //link.setAttribute('open', item.id +'.pdf');
      //   // document.body.appendChild(link);
      //   // link.click();

      //   this.progress = true
      //   this.$store
      //     .dispatch("_EDICTOS", item.id)
      //     .then((response) => {
      //       const url = window.URL.createObjectURL(new Blob([response[0].data], { type: 'application/pdf' }));
      //       const link = document.createElement('a');
      //       link.href = url;
      //       link.setAttribute('target' ,'_blank');
      //       // link.setAttribute('download', item.id +'.pdf');

      //       document.body.appendChild(link);
      //       link.click();
      //       this.progress = false
      //     })
      //     .catch(err => {
      //       console.log(err);
      //     });
      // },
      deleteEdicto(item){
        var expediente = item.numero + '-' + item.periodo
        if (item.derivado) {
          expediente = expediente + '-' + item.derivado
        }
        this.$swal({
          title: '¿Eliminar Edicto ' + expediente +'?',
          text: '',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: "Aceptar"
        }).then((result) => {
          if (result.value) {
            this.$store.dispatch("DELETE_EDICTO",  { url: "/edicto/" + item.id } ).then(res => {
              Swal.fire({
                icon: 'success',
                title: 'Edicto eliminado correctamente.',
                confirmButtonText: "Aceptar"
              })
              this.buscar()
              // if(this.roleUser == 'enlace'){
              //   // this.getTocasCount()
              // }
            })
            .catch(err => {
              console.log(err);
            });
          }
        })
      },
      
      close () {
        this.$refs.form.resetValidation()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
        this.file = []
        this.files = []
        this.archivo = { encode: '' }
        this.listJuzgadosForm = []
      },
      openRetryUpload(item) {
        this.retryItem = item
        this.retryFile = null
        this.dialogRetryUpload = true
      },
      closeRetryUpload() {
        this.dialogRetryUpload = false
        this.retryItem = null
        this.retryFile = null
      },
      async retryUploadEdicto() {
        if (!this.retryFile) return

        this.loadingRetry = true
        try {
          // 1. Solicitar presigned URL para el edicto existente
          const response = await this.$store.dispatch("RETRY_UPLOAD_EDICTO", {
            url: "/edicto/" + this.retryItem.id + "/retry-upload",
            data: { file_name: this.retryFile.name }
          })

          const { url, edicto_name, edicto } = response.data

          // 2. Subir archivo a S3
          await axios.put(url, this.retryFile, {
            headers: { 'Content-Type': 'application/pdf' }
          })

          // 3. Confirmar subida al backend
          await this.$store.dispatch("CONFIRM_UPLOAD_EDICTO", {
            url: "/edicto/confirm-upload",
            data: { edicto_id: edicto.id, edicto_name: edicto_name }
          })

          Swal.fire({
            icon: 'success',
            title: 'Archivo subido correctamente',
            showConfirmButton: false,
            timer: 1500
          })
          this.closeRetryUpload()
          this.buscar()
        } catch (err) {
          console.log(err)
          let errorMsg = 'No se pudo subir el archivo'
          if (err.response && err.response.data && err.response.data.message) {
            errorMsg = err.response.data.message
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMsg,
            confirmButtonText: 'Aceptar'
          })
        } finally {
          this.loadingRetry = false
        }
      },
    }

  }
</script>

<style scoped>
  .parrafo {
    color: #000000;
    font-size: 15px;
    text-align: justify;
    font-family: inherit;
    font-weight: normal;
    line-height: 1.6;
    margin-bottom: 17px;
  }
</style>
